import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Fields, reduxForm, reset } from 'redux-form';
import DOMPurify from 'dompurify';
import { Button, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  TextInput,
  TextArea,
  Select,
  FormErrorMessages,
  generateValidation,
} from 'ecs-react-components/dist/index.es';
import validations from './SecureMessageForm.validations';
import { messages } from './SecureMessageForm.i18n';
import { loadLegalMessage, sendSecureMessage } from '../../redux/modules/secure-message/secure-message-middleware';


const fields = ['recipient', 'subject', 'content'];

class SecureMessageForm extends Component {
  componentDidMount() {
    this.props.dispatch(loadLegalMessage(this.props.facility.facilityId, this.props.languageCode));
  }

  onSubmit = (formValues) => {
    const { userId, languageCode, timeZone, timeZoneOffset, dispatch } = this.props;
    dispatch(sendSecureMessage({
      patientId: this.props.patient.patientId,
      careProviderId: formValues.recipient,
      subjectText: formValues.subject,
      messageText: formValues.content,
      userId,
      successRoute: !this.props.initiatedfromMessagesModule ? '/' : null,
      languageCode,
      timeZone,
      timeZoneOffset,
      compact: this.props.compact,
    }));
    this.props.close();
  }

  createLegalMessageMarkup = () => {
    const html = { __html: DOMPurify.sanitize(this.props.legalMessage) };
    return html;
  };

  close = () => {
    this.props.dispatch(reset('securemessageform'));
    this.props.close();
  }

  renderFields = (fieldsMeta) => {
    const { formatMessage } = this.props.intl;
    const { recipient, subject, content } = fieldsMeta;
    const hasSecureMessaging = (person) =>
      person &&
      person.preferredSecureMessageIfSystemId &&
      person.preferredSecureMessageIfSystemId > 0 &&
      person.secureMessageRecipientForPatient;

    const careTeamWithSecureMessaging = this.props.careTeam ? this.props.careTeam.filter(hasSecureMessaging) : [];
    const careTeamSelectOptions = careTeamWithSecureMessaging.map((member) => {
      const option = {};
      option.key = member.careProviderId;
      option.value = member.careProviderId;
      option.displayValue = member.firstName + ' ' + member.lastName;
      return option;
    });
    return (
      <div>
        <div className="form-group">
          <label className="control-label form-label" htmlFor={recipient.input.name} >
            {formatMessage(messages.recipient.placeholder)}
            <FormErrorMessages field={recipient} />
          </label>
          <Select
            field={recipient}
            options={careTeamSelectOptions}
          />
        </div>
        <div className="form-group">
          <label className="control-label form-label" htmlFor={subject.input.name}>
            {formatMessage(messages.subject.placeholder)}
            <FormErrorMessages field={subject} />
          </label>
          <TextInput
            field={subject}
            maxLength={validations.subject.maxLength}
          />
        </div>
        <div className="form-group">
          <label className="control-label form-label" htmlFor={content.input.name}>
            {formatMessage(messages.content.placeholder)}
            <FormErrorMessages field={content} />
          </label>
          <TextArea field={content} placeholder={formatMessage(messages.message.placeholder)}
            rows={10} maxLength={validations.content.maxLength}
          />
        </div>
      </div>
    );
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { handleSubmit } = this.props;

    return (
      <Modal show={this.props.showModal} onHide={ this.close } backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{formatMessage(messages.page.header)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-header" dangerouslySetInnerHTML={ this.createLegalMessageMarkup() } />
          <form onSubmit={handleSubmit(this.onSubmit)}>
            <Fields names={fields} component={this.renderFields} />
            <Modal.Footer>
              <Button type="submit" className="btn btn-primary">
                <FormattedMessage {...messages.send.label} />
              </Button>
              <Button type="button" className="btn btn-default" onClick={ this.close }>
                <FormattedMessage {...messages.cancel.label} />
              </Button>
            </Modal.Footer>
          </form>
        </Modal.Body>
      </Modal>
    );
  }
}

SecureMessageForm.propTypes = {
  intl: PropTypes.object,
  patient: PropTypes.object,
  facility: PropTypes.object,
  dispatch: PropTypes.func,
  careTeam: PropTypes.array,
  legalMessage: PropTypes.string,
  handleSubmit: PropTypes.func,
  recipient: PropTypes.string,
  userId: PropTypes.number,
  showModal: PropTypes.bool,
  close: PropTypes.func,
  initiatedfromMessagesModule: PropTypes.bool,
  timeZone: PropTypes.string,
  timeZoneOffset: PropTypes.string,
  languageCode: PropTypes.string,
  compact: PropTypes.bool,
};

const formConfig = {
  form: 'securemessageform',
  ...generateValidation(validations),
};

const mapStateToProps = (state) => ({
  patient: state.profile.patient,
  facility: state.facility,
  careTeam: state.careTeam.members,
  legalMessage: state.secureMessage.legalMessage,
  userId: state.profile.user.userId,
  timeZone: state.facility.timeZoneAbbreviation,
  timeZoneOffset: state.facility.timeZoneOffset,
  languageCode: state.language.languageCode,
});

export default reduxForm(formConfig)(connect(mapStateToProps)(injectIntl(SecureMessageForm)));
